import React, { FC, useEffect, useState } from 'react';
import { useInView } from 'react-hook-inview';
import { useTranslation } from 'react-i18next';

import {
  ValuesStyled,
  Title,
  BubbleContainer,
  Bubble,
  DiagonalWhite,
} from './style';

interface Props {}

const Main: FC<Props> = () => {
  const [bubleOne, setBubleOne] = useState([]);
  const [bubleTwo, setBubleTwo] = useState([]);
  const [bubleThree, setBubleThree] = useState([]);
  const [bubleFour, setBubleFour] = useState([]);
  const { t } = useTranslation();
  const [targetRef, isInViewport] = useInView({
    unobserveOnEnter: true,
  });
  useEffect(() => {
    setBubleOne(t('CompanyValuesBuble1Text', { returnObjects: true }));
    setBubleTwo(t('CompanyValuesBuble2Text', { returnObjects: true }));
    setBubleThree(t('CompanyValuesBuble3Text', { returnObjects: true }));
    setBubleFour(t('CompanyValuesBuble4Text', { returnObjects: true }));
  }, [t]);
  return (
    <ValuesStyled>
      <DiagonalWhite />
      <div className="container">
        <Title>{t('CompanyValuesTitle')}</Title>
        <BubbleContainer ref={targetRef}>
          <Bubble
            className={
              isInViewport ? 'top-left transitioning' : 'top-left hide'
            }
          >
            <div className="number">1</div>
            <h4>{t('CompanyValuesBuble1Title')}</h4>
            <div className="text">
              {/* .values.ul definida en App.css */}
              <ul className="values-ul">
                {bubleOne.map((e: string, index: number) => (
                  <li key={index}>{e}</li>
                ))}
              </ul>
            </div>
          </Bubble>
          <Bubble
            className={
              isInViewport ? 'top-right transitioning' : 'top-right hide'
            }
          >
            <div className="number">2</div>
            <h4>{t('CompanyValuesBuble2Title')}</h4>
            <div className="text">
              <ul className="values-ul">
                {bubleTwo.map((e: string, index: number) => (
                  <li key={index}>{e}</li>
                ))}
              </ul>
            </div>
          </Bubble>
          <Bubble
            className={
              isInViewport ? 'bottom-left transitioning' : 'bottom-left hide'
            }
          >
            <div className="number">3</div>
            <h4>{t('CompanyValuesBuble3Title')}</h4>
            <div className="text">
              <ul className="values-ul">
                {bubleThree.map((e: string, index: number) => (
                  <li key={index}>{e}</li>
                ))}
              </ul>
            </div>
          </Bubble>
          <Bubble
            className={
              isInViewport ? 'bottom-right transitioning' : 'bottom-right hide'
            }
          >
            <div className="number">4</div>
            <h4>{t('CompanyValuesBuble4Title')}</h4>
            <div className="text">
              <ul className="values-ul">
                {bubleFour.map((e: string, index: number) => (
                  <li key={index}>{e}</li>
                ))}
              </ul>
            </div>
          </Bubble>
        </BubbleContainer>
      </div>
    </ValuesStyled>
  );
};

export default Main;
